import React from 'react';

const GoogleContext = React.createContext();

export default GoogleContext;
